/** Client-side mirror of server applicationClientVisibility.js */

export function isPendingClientSubmission(app) {
  if (!app || app.stage !== 'submitted') return false;
  if (app.pendingClientSubmission === true) return true;
  if (app.submittedToClient === false) return true;
  return !app.submittedToClientAt;
}

export function isSharedWithClient(app) {
  if (!app || app.stage !== 'submitted') return true;
  return Boolean(app.submittedToClientAt || app.submittedToClient);
}

export function clientAccessLabel(app) {
  if (app?.stage !== 'submitted') return null;
  return isPendingClientSubmission(app) ? 'Internal review' : 'Shared with client';
}
